import accountSettingsModule from '../accountSettingsModule';

function accountPinStatus(accountConstantsResources) {
  'ngInject';

  return {
    restrict: 'A',
    templateUrl: accountConstantsResources.templates.accountPinStatus
  };
}

accountSettingsModule.directive('accountPinStatus', accountPinStatus);

export default accountPinStatus;
